import { FC, useEffect } from 'react';
import { Slide, SlideComponentProps } from './Slide';
import { RenderField } from '@/form/fields/RenderField.tsx';
import { useForm } from '@/form/useForm.ts';
import { ConfigSlideId } from '@/eventConfig/types';

type BmiProps = SlideComponentProps;

export const Bmi: FC<BmiProps> = ({ slide, ...props }) => {
  const { getFieldValue, onChange } = useForm();

  const defaultUnit = slide.defaultunit || 'metric';
  const unit = getFieldValue('units') ?? defaultUnit;

  const unitsField = slide.fields.find(({ name }) => name === 'units');

  // Metrics
  const heightField = slide.fields.find(({ name }) => name === 'height');
  const weightField = slide.fields.find(({ name }) => name === 'weight');

  // Retardunits
  const heightFtField = slide.fields.find(({ name }) => name === 'heightFt');
  const heightInField = slide.fields.find(({ name }) => name === 'heightIn');

  // Display BMI
  const bmiDisplayField = slide.fields.find(({ name }) => name === 'bmidisplay');
  const weightStField = slide.fields.find(({ name }) => name === 'weightSt');
  const weightLbField = slide.fields.find(({ name }) => name === 'weightLb');

  useEffect(() => {
    if (unitsField) {
      onChange('units', {
        value: { raw: defaultUnit, normalized: defaultUnit },
        isValid: true,
        hint: undefined,
        slideId: 'bmi',
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    // Reset the values in the "other" fields so they dont get transmitted
    const reset = {
      value: { raw: null, normalized: null },
      isValid: true,
      hint: undefined,
      slideId: 'bmi' as ConfigSlideId,
    };

    if (unit === 'metric') {
      onChange('heightFt', reset);
      onChange('heightIn', reset);
      onChange('weightSt', reset);
      onChange('weightLb', reset);
    }
    if (unit === 'imperial') {
      onChange('height', reset);
      onChange('weight', reset);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [unit]);

  const cssClasses = ['type-question', 'num-fields-' + slide.fields.length];

  if (unit === 'metric') {
    return (
      <div>
        <Slide {...props} slide={slide} className={cssClasses.join(' ')}>
          <RenderField slideId={'bmi'} field={unitsField!} />
          <RenderField slideId={'bmi'} field={heightField!} />
          <RenderField slideId={'bmi'} field={weightField!} />
          <RenderField slideId={'bmi'} field={bmiDisplayField!} />
        </Slide>
      </div>
    );
  } else {
    return (
      <Slide {...props} slide={slide} className={cssClasses.join(' ')}>
        <RenderField slideId={'bmi'} field={unitsField!} />
        <RenderField slideId={'bmi'} field={weightStField!} />
        <RenderField slideId={'bmi'} field={weightLbField!} />
        <RenderField slideId={'bmi'} field={heightFtField!} />
        <RenderField slideId={'bmi'} field={heightInField!} />
        <RenderField slideId={'bmi'} field={bmiDisplayField!} />
      </Slide>
    );
  }
};
